import mixpanel from 'mixpanel-browser'

import { IS_PRODUCTION, MIXPANEL } from 'Config/app'

if (IS_PRODUCTION) {
  mixpanel.init(MIXPANEL.TOKEN)
}

const Mixpanel = {
  track: (event: string, properties?: Record<string, any>) => {
    if (!IS_PRODUCTION) return

    mixpanel.track(event, properties)
  },

  reset: () => {
    if (!IS_PRODUCTION) return

    mixpanel.reset()
  },
}

export default Mixpanel
